export default __webpack_public_path__ + "static/egp2@2x-995633d43b67bd96d4444141bd87d433.jpg";